<template>
  <div class="registration-form-section">
    <div class="registration-form-holder">
      <SectionHeading>MyLittlePonyCollection Is Always <span class="highlight">Free</span></SectionHeading>
      <h2 class="registration-form-directions">To create your account and start tracking your collection fill out the form below.</h2>
      <div class="form-holder">
        <FormRegister />
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeading from '../SectionHeading/SectionHeading';
import FormRegister from '../FormRegisterUser/FormRegisterUser';

// * register new user
// * automatically login new user
// * after the account is created and the new user is logged in display a walkthrough modal
// * show herd
// * show wishlist
// * show favorites list

export default {
  name: 'Register',
  components: {
    SectionHeading,
    FormRegister
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.registration-form-section {
  background: url('../../assets/images/get-started-bg.jpg') no-repeat $blue-grey;
  background-size: cover;
  background-attachment: fixed;
  // background-color: $blue-grey;
  padding: 60px 10px;

  .section-heading {
    color: $accent-color;

    .highlight {
      color: #fff;
    }
  }
}

.registration-form-directions {
  font-size: 18px;
  text-align: center;
  color: #fff;
  max-width: 520px;
  margin: auto;
  padding-bottom: 20px;
}

</style>
